import * as Sentry from '@sentry/react';
import { env } from './env';

/**
 * Initialize Sentry for error monitoring and performance tracking
 * Should be called before rendering the React application
 */
export function initSentry() {
  // Skip initialization if DSN is not provided
  if (!env.VITE_SENTRY_DSN) {
    console.warn('Sentry DSN not provided, skipping Sentry initialization');
    return;
  }

  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    environment: env.VITE_ENVIRONMENT,

    // Release tracking for associating errors with specific versions
    // Set via VITE_RELEASE_VERSION environment variable during build
    release: import.meta.env.VITE_RELEASE_VERSION,

    // Browser tracing integration for performance monitoring
    integrations: [Sentry.browserTracingIntegration()],

    // Performance monitoring sample rate
    // Adjust in production based on traffic volume
    tracesSampleRate: env.VITE_ENVIRONMENT === 'production' ? 0.1 : 1.0,

    // Set trace propagation targets for distributed tracing
    // Include localhost and our production/staging domains
    tracePropagationTargets: ['localhost', /^https?:\/\/.*\.(lkty\.me|mailgobbler\.com)/],

    // Add user context to error reports
    beforeSend(event, _hint) {
      // User context will be added by route loaders or session watcher
      // when they have access to the session data
      return event;
    },
  });
}

/**
 * Re-export Sentry for use in the application
 * Allows components to use Sentry.captureException, etc.
 */
export { Sentry };
